import React from "react";
import { Fragment } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./empty.module.css";

const Empty = () => {
  const navigate = useNavigate();
  const routhHandler = () => {
    navigate("./add-car");
  };

  return (
    <Fragment>
      <div class="alert alert-warning border-0 shadow-sm rounded-3 p-4" role="alert" dir="rtl" style={{ fontFamily: "Vazir, sans-serif", lineHeight: "1.9" }}>
        <div class="d-flex align-items-center mb-2">
          <i class="bi bi-exclamation-triangle-fill fs-4 me-2 text-warning"></i>
          <h5 class="fw-bold mb-0">کاربر گرامی</h5>
        </div>
        <p class="mb-2">
          پس از <strong>ثبت‌نام</strong>، به مدت <strong>۳۰ روز</strong> می‌توانید از تمامی امکانات برنامه استفاده نمایید و از صحت عملکرد آن در دستگاه خود اطمینان حاصل کنید.
        </p>
        <p class="mb-3">
          پس از پایان این مدت، با <strong>خرید اشتراک سالانه</strong> همچنان از تمام قابلیت‌ها بهره‌مند خواهید شد. در غیر این صورت، برنامه به‌صورت <strong>محدود</strong> در دسترس شما خواهد بود.
        </p>
        <a href="#" class="btn btn-outline-warning btn-sm fw-bold">
          خرید اشتراک سالانه
        </a>
      </div>

      {/* <div class="alert alert-warning" >
        <strong>کاربر گرامی!</strong> 
        بعد از ثبت نام تا 90 روز می توانید از کلیه امکانات برنامه استفاده نمایید و از صحت عملکرد آن روی گوشی خود اظمینان حاصل کنید. پس از آن با خرید اشتراک سالانه امکان اسنفاده از تمامی امکانات را دارید و در غیر اینصورت برنامه شما بصورت محدود قابل استفاده می باشد.
      </div> */}
      <div className="d-flex justify-content-center align-items-center bg-light px-3" dir="rtl">
        <div>
          {/* <p className="mb-4">
            جهت تعریف خودروی جدید از این قسمت شروع کنید.
          </p> */}
          <button
            type="button"
            className="btn btn-info btn-lg text-white w-100"
            onClick={routhHandler}
          >
            خودروی جدید
          </button>
        </div>
      </div>
    </Fragment>
  );
};

export default Empty;
